<section class="integrations-section integrations-add">
  <div class="integrations-add__header">
    <h2 class="integrations-section__title">Add company-wide integrations</h2>
    <p class="integrations-add__subtitle">
      Connect your organization's favorite tools to seamlessly sync data,
      automate workflows, and power up your presentations.
    </p>
  </div>
  <div
    class="integrations-grid"
    rvSpinner="integrations-company-add-section"
    [rvShowSpinner]="actionLoading()"
    [attr.aria-busy]="initialLoading() || actionLoading() ? 'true' : null"
  >
    @if (initialLoading()) {
      <div
        class="integration-company-add-card-skeleton"
        role="status"
        aria-label="Loading integrations"
      >
        @for (card of [1, 2, 3]; track card) {
          <div
            class="integration-company-add-card-skeleton__card"
            aria-hidden="true"
          >
            <rv-skeleton
              class="integration-company-add-card-skeleton__logo"
              [height]="52"
            />
            <div class="integration-company-add-card-skeleton__text">
              <rv-skeleton
                class="integration-company-add-card-skeleton__name"
                [height]="20"
              />
              <rv-skeleton
                class="integration-company-add-card-skeleton__description"
                [height]="20"
              />
              <rv-skeleton
                class="integration-company-add-card-skeleton__description"
                [height]="20"
              />
            </div>
            <rv-skeleton
              class="integration-company-add-card-skeleton__button"
              [height]="40"
            />
          </div>
        }
      </div>
    } @else {
      @for (integration of integrations(); track integration.id) {
        <integration-company-add-card
          [integration]="integration"
          (add)="onAdd($event)"
        ></integration-company-add-card>
      }
    }
  </div>
</section>
